<template>
    <div>FAQ</div>
</template>

<script>
    export default {
        name: 'faq',
        metaInfo() {
            let title = "All Cricket Matches, Score, Update, Schedule, Upcoming";
            let description = "Get all the latest cricket news, live scores, results, match schedules, articles, player & team updates, and cricket videos - PlanetCricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }

        },
    }
</script>
